import { cn } from "@/lib/hooks/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/ui-components/ui/tooltip";
import { CheckCircle2, Clock, HelpCircle, XCircle } from "lucide-react";

interface JourneyTimelineProps {
  journey: string[];
}

export function JourneyTimeline({ journey }: JourneyTimelineProps) {
  const journeySteps = [
    { id: "start", label: "Start", category: "start", icon: HelpCircle },
    { id: "no-interest", label: "Kein Interesse", category: "lost", icon: XCircle },
    { id: "wasnt-there", label: "Nicht anwesend", category: "pending", icon: Clock },
    { id: "thinking", label: "Überlegt", category: "pending", icon: Clock },
    { id: "received-offer", label: "Angebot erhalten", category: "pending", icon: Clock },
    { id: "didnt-sell", label: "Nicht verkauft", category: "lost", icon: XCircle },
    { id: "sold", label: "Verkauft", category: "won", icon: CheckCircle2 },
    { id: "technical-not-possible", label: "Technisch nicht möglich", category: "lost", icon: XCircle },
  ];

  const getStepColor = (category: string) => {
    switch (category) {
      case "start":
        return "bg-blue-500 text-white";
      case "pending":
        return "bg-amber-500 text-white";
      case "lost":
        return "bg-red-500 text-white";
      case "won":
        return "bg-green-500 text-white";
      default:
        return "bg-gray-500 text-white";
    }
  };

  const getConnectorColor = (fromCategory: string) => {
    switch (fromCategory) {
      case "start":
        return "bg-blue-500";
      case "pending":
        return "bg-amber-500";
      case "lost":
        return "bg-red-500";
      case "won":
        return "bg-green-500";
      default:
        return "bg-gray-500";
    }
  };

  // Find the steps that are in the journey
  const activeSteps = journeySteps.filter((step) => journey.includes(step.id));

  return (
    <TooltipProvider>
      <div className="flex flex-wrap items-center gap-1 md:gap-2">
        {activeSteps.map((step, index) => (
          <div key={step.id} className="flex items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center">
                  <div
                    className={cn(
                      "flex h-7 items-center rounded-md px-1.5 text-xs font-medium",
                      "md:h-8 md:px-2",
                      getStepColor(step.category)
                    )}
                  >
                    <step.icon className="h-3 w-3 md:mr-1" />
                    <span className="hidden md:inline">{step.label}</span>
                  </div>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>{step.label}</p>
              </TooltipContent>
            </Tooltip>

            {index < activeSteps.length - 1 && (
              <div className={cn("h-0.5 w-2 md:w-4 mx-0.5 md:mx-1", getConnectorColor(step.category))} />
            )}
          </div>
        ))}
      </div>
    </TooltipProvider>
  );
}
